import { useState } from "react";
import { CartProduct } from "../utils/cartTypes";
import { updateProductQuantity } from "../utils/utils";

type UseProduct = (product: CartProduct) => {
    handleMinus: () => Promise<void>;
    handlePlus: () => Promise<void>;
    handleRemove: () => Promise<void>;
    isUpdating: boolean;
};

export const useProduct: UseProduct = (product: CartProduct) => {
    const [isUpdating, setIsUpdating] = useState(false);
    const quantity = product.quantity;

    const handleMinus = async () => {
        setIsUpdating(true);
        if (quantity > 1) await updateProductQuantity(product.key, quantity - 1);
        setIsUpdating(false);
    };

    const handlePlus = async () => {
        setIsUpdating(true);
        if (quantity < 100) await updateProductQuantity(product.key, quantity + 1);
        setIsUpdating(false);
    };

    const handleQuantity = async (quantity: number) => {
        setIsUpdating(true);
        await updateProductQuantity(product.key, quantity);
        setIsUpdating(false);
    };

    const handleRemove = async () => {
        setIsUpdating(true);
        await updateProductQuantity(product.key, 0);
        setIsUpdating(false);
    };

    return {
        handleMinus,
        handlePlus,
        handleQuantity,
        handleRemove,
        isUpdating,
    };
};
